import {Component, ChangeDetectionStrategy} from '@angular/core';
import {sendQuery} from 'src/app/common/utils';
import {VisitContext} from '../../visit-context';
import {PortvisitUtils} from "../../../refdata/portvisit-utils";

@Component({
    selector: 'app-nautical-services-inbound',
    templateUrl: './nautical-services-inbound.component.html',
    styleUrls: ['./nautical-services-inbound.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NauticalServicesInboundComponent {
  areNauticalServicesApplicable = PortvisitUtils.areNauticalServicesApplicable;
  hasPilots = PortvisitUtils.hasPilots;
  hasTugboats = PortvisitUtils.hasTugboats;
  hasBoatmen = PortvisitUtils.hasBoatmen;
  hasHelmsmen = PortvisitUtils.hasHelmsmen;

  context = VisitContext;

  pilotProvider = sendQuery('com.portbase.bezoekschip.common.api.visit.GetPilots', {
    portUnCode: this.context.visit.portOfCall.port.locationUnCode
  });
  tugboatProvider = sendQuery('com.portbase.bezoekschip.common.api.visit.GetTugboats', {
    portUnCode: this.context.visit.portOfCall.port.locationUnCode
  });
  boatmenProvider = sendQuery('com.portbase.bezoekschip.common.api.visit.GetBoatmen', {
    portUnCode: this.context.visit.portOfCall.port.locationUnCode
  });
  helmsmenProvider = sendQuery('com.portbase.bezoekschip.common.api.visit.GetHelmsmen', {
    portUnCode: this.context.visit.portOfCall.port.locationUnCode
  });

  get pilotNotPossible(): boolean {
    return VisitContext.visit.visitDeclaration.portVisit.firstMovement.pilotService?.required
      && VisitContext.accessPointsAsPilotBoardingPlaces()
      && !VisitContext.visit.visitDeclaration.portVisit.pilotStation
      && !!VisitContext.visit.visitDeclaration.portVisit.entryPoint;
  }
}
